export const stripHtml = (html: string) =>
  html.replace(/<[^>]*>/g, "").replace(/\s/g, "");

export function formatCPF(value: string) {
  return value
    .replace(/\D/g, "")
    .slice(0, 11)
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
}

export function formatCNPJ(value: string) {
  return value
    .replace(/\D/g, "")
    .slice(0, 14)
    .replace(/(\d{2})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1/$2")
    .replace(/(\d{4})(\d{1,2})$/, "$1-$2");
}

export function formatCPFCNPJ(value: string) {
  const cleaned = value.replace(/\D/g, "");
  if (cleaned.length <= 11) {
    return formatCPF(cleaned);
  }
  return formatCNPJ(cleaned);
}

export function formatCEP(value: string) {
  return value
    .replace(/\D/g, "")
    .slice(0, 8)
    .replace(/(\d{5})(\d)/, "$1-$2");
}

export function formatPhone(value: string) {
  const cleaned = value.replace(/\D/g, "").slice(0, 11);
  if (cleaned.length <= 10) {
    return cleaned
      .replace(/(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d{4})$/, "$1-$2");
  }
  return cleaned
    .replace(/(\d{2})(\d)/, "($1) $2")
    .replace(/(\d{5})(\d{4})$/, "$1-$2");
}

export function formatMoneyBr(
  value: number | string | null | undefined,
): string {
  if (value == null || isNaN(Number(value))) {
    return "R$ 00,00";
  }

  const numericValue = typeof value === "string" ? parseFloat(value) : value;

  return numericValue.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

export function formatDateToBr(date: Date | string): string {
  date = new Date(date);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // mês começa em 0
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function formatDateToYMD(date: Date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}/${month}/${day}`;
}

export function formatKms(value: number | string): string {
  if (value == null || isNaN(Number(value))) {
    return "0 km";
  }

  const numericValue =
    typeof value === "string" ? parseFloat(value).toFixed(0) : value;

  const sigla = "km";

  return `${numericValue.toLocaleString("pt-BR")} ${sigla}`.trim();
}
